import React from 'react'
import { values, omit, sortBy } from 'lodash'
import { Modal, Checkbox } from 'react-bootstrap'
import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'

import "./tags.less"

type TSProps = {
  allTag: { [string]: { _id: string, name: string } },
  selectedTags: { [string]: boolean },
  onChange: Object => void
}

type MTSProps = {
  allTag: { [string]: { _id: string, name: string } },
  selectedTags: { [string]: boolean },
  onChange: Object => void,
  onEditClick: () => void,
  onClose: () => void,
}

export const TagsSelector = (props: TSProps) => (
  <div className="TagsSelector">
    {
      sortBy(values(props.allTags), tag => tag.name)
        .map(tag => (
          <span className="Tag" key={tag._id}> 
            <Checkbox
              inline
              checked={props.selectedTags[tag._id]}
              onChange={evt => {
                props.onChange({
                  ...props.selectedTags,
                  [tag._id]: evt.target.checked
                })
              }}
            >
              #{tag.name}
            </Checkbox>
          </span>
        ))
    }
  </div>
)

export const ModalTagsSelector = (props: MTSProps) => (
  <Modal show onHide={props.onClose}>
    <Modal.Header>
      <Modal.Title>
        {getText("Etiquetas")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <TagsSelector {...omit(props, "onClose")} />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={props.onEditClick}>
        {getText("Editar etiquetas")}
      </Button>
      <Button bsStyle="primary" onClick={props.onClose}>
        {getText("Aceptar")}
      </Button>
    </Modal.Footer>
  </Modal>
)
